import script from "./IconButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconButtons.vue?vue&type=script&lang=ts&setup=true"

import "./IconButtons.vue?vue&type=style&index=0&id=74e8b000&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e8b000"]])

export default __exports__